import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { LanguageService, WindowRef } from '@spartacus/core';

export const htmlLangProvider: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = setHtmlLangAttribute(
    inject(WindowRef),
    inject(LanguageService)
  );
  return initializerFn();
});

/**
 * Sets active language in <html lang="">
 */
export function setHtmlLangAttribute(winRef: WindowRef, languageService: LanguageService): () => void {
  const result = () => {
    languageService.getActive().subscribe((lang) => {
      winRef.document.documentElement.lang = lang.replace(/_/g, '-');
    });
  };
  return result;
}
